module.exports = __webpack_public_path__ + "img/PYTHON_LOGO.34481e60.png";